import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import i18next from 'i18next';
function degsToRadians(degs) {
  return (degs / 360) * (2 * Math.PI)
}

class ProgressBar extends React.Component {

  static propTypes = {
    colors: PropTypes.array,
    data: PropTypes.array.isRequired,
    size: PropTypes.number,
    lineWidth: PropTypes.number
  };

  static defaultProps = {
    colors: ['RGB(68, 212, 59)', '#f5f5f5', '#ef7b45', '#d84727'],
    size: 145,
    lineWidth: 19
  };
  componentDidMount() {
    const {
      data = [],
      text = 0
    } = this.props;

    if (data.length !== 0) {
      this.draw()
    }
  }

  componentDidUpdate(prevProps) {
    const {
      data = [],
      text = 0
    } = this.props;

    if (text !== prevProps.text && data.length !== prevProps.length) {
      if (data.length > 0)
        this.draw();
    }
    if(this.props.lang !== prevProps.lang){
      this.draw();
    }
  }

  draw() {
    const canvas = ReactDOM.findDOMNode(this);
    const c = canvas.getContext('2d');
    c.clearRect(0, 0, canvas.width, canvas.height)
    const center = this.props.size / 2;
    const lineWidth = this.props.lineWidth;
    const radius = center - (lineWidth / 2);
    c.lineWidth = lineWidth;
    c.font = "bolder 42px Roboto";
    c.fillStyle = "black";
    c.textAlign = "center";
    c.fillText(`${this.props.text}`, center, 80);
    c.font = "normal 12px Roboto"
    c.fillStyle = "black"
    c.fillText(i18next.t("lable.handsPlayed"), center, 100)

    const dataTotal = this.props.data.reduce((r, dataPoint) => r + dataPoint, 0);

    let startAngle = degsToRadians(270);
    let colorIndex = 0;
    this.props.data.forEach((dataPoint, i) => {
      const section = dataPoint / dataTotal * 360;
      const endAngle = startAngle + degsToRadians(section);
      const color = this.props.colors[colorIndex];
      colorIndex++;
      if (colorIndex >= this.props.colors.length) {
        colorIndex = 0;
      }
      c.strokeStyle = color;
      c.beginPath();
      c.arc(center, center, radius, startAngle, endAngle);
      c.stroke();
      startAngle = endAngle;
    });
  }

  render() {
    return (
      <canvas
        height={'150px'}
        width={'147px'}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    lang: state.header.lang
  };
};

export default connect(mapStateToProps, null)(ProgressBar)


/** WEBPACK FOOTER **
 ** ./src/components/ReportCard/ProgressBar.js
 **/